export default __webpack_public_path__ + "static/media/tree-num-one.e56b0b79.png";